<template src="./RenunciaView.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem, Divider} from "element-ui";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {RouterMixin} from "@/mixins/routerMixin";
import moment from "moment-timezone";
import {requestRenunciaPPMixin} from "@/api/partidoPolitico/renunciaPPApi";
import RenunciaDetail from "@/components/Shared/RenunciaDetail/RenunciaDetail";

export default {
  name: "RenunciaView",
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    RenunciaDetail
  },
  mixins: [
    requestRenunciaPPMixin,
    NotifyMixin,
    ScreenSizeMixin,
    RouterMixin,
  ],
  data() {
    return {
      loading: true,
      errored: false,
      inRoute: false,
      collapse: ['1'],
      model: {
        id: "",
        rut: "",
        nombreCompleto: "",
        domicilio: "",
        fechaNacimiento: "",
        email: "",
        telefonoMovil: "",
        telefonoFijo: "",
        estado: '',
        renunciaFecha: new Date(),
        renunciaFechaHora: new Date(),
        afiliacionFecha: new Date(),
        afiliacionFechaHora: new Date(),
        partidoNombre: ''
      },
    }
  },
  props: {
    idRenuncia: {
      type: String,
      required: false
    }
  },
  beforeMount() {
    this.getIdRenuncia()
    this.getData()
  },
  methods: {
    getIdRenuncia() {
      if (this.$route.params.hasOwnProperty('id')) {
        this.model.id = this.$route.params.id
        this.inRoute = true
        this.collapse.push('2')
        this.collapse.push('3')
      } else {
        this.model.id = this.idRenuncia
      }
    },
    getData() {
      this.getRenunciaVer(this.model.id)
        .then((response) => {
          this.$log.debug('getRenunciaVer', response.data.statusCode)
          if (response.data.statusCode === 200) {
            const data = JSON.parse(response.data.datos);
            this.$log.debug(data)

            this.model.rut = data.cedula
            this.model.nombreCompleto = data.nombrecompleto
            this.model.fechaNacimiento = moment(data.fechanacimiento, "YYYYMMDD").format('DD-MM-YYYY')
            this.model.email = data.email
            this.model.domicilio = data.domicilio
            this.model.telefonoMovil = data.telefonomovil
            this.model.telefonoFijo = data.telefonofijo
            this.model.estado = data.estado
            this.model.renunciaFecha = moment.utc(data.fecha).local().format("DD-MM-YYYY")
            this.model.renunciaFechaHora = moment.utc(data.fecha).local().format("h:mm a")

            this.model.afiliacionFecha = moment.utc(data.fechaafiliacion).local().format("DD-MM-YYYY")
            this.model.afiliacionFechaHora = moment.utc(data.fechaafiliacion).local().format("h:mm a")

            this.model.partidoNombre = data.partidonombre
          } else {
            this.errored = true;
            this.showInfo('No hay datos de su persona')
          }
        })
        .catch((err) => {
          this.errored = true
          this.$log.fatal('getRenunciaVer', err, err.response, err.request)
          this.showError("Error al cargar la data de Renuncia")
        })
        .finally(() => {
          this.loading = false
        })
    },
    downloadDocument() {
      const data = this.model.documentoComprobante
      let link = document.createElement('a')
      link.href = data
      const date = moment(new Date()).format('YYYYMMDDhhmmss')
      link.download = `documento-renuncia-${date}.pdf`
      link.click();
    }
  }
}
</script>
